<div class="bar-holder">
  <div class="bar-progress" [style.width]="width + '%'"></div>
</div>
